import { render, staticRenderFns } from "./companywisereport.vue?vue&type=template&id=4d494cbc&scoped=true&"
import script from "./companywisereport.vue?vue&type=script&lang=js&"
export * from "./companywisereport.vue?vue&type=script&lang=js&"
import style0 from "./companywisereport.vue?vue&type=style&index=0&id=4d494cbc&prod&lang=css&"
import style1 from "./companywisereport.vue?vue&type=style&index=1&id=4d494cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d494cbc",
  null
  
)

export default component.exports